import { useCallback } from "react";
import {
  type DeleteConfirmOptions,
  useDeleteConfirm,
} from "./useDeleteConfirm";

export type ConfirmDeleteProp = boolean | DeleteConfirmOptions;

/**
 * Optionally prompts for delete confirmation before invoking onClick.
 * Cancel closes the dialog and skips the action (no error thrown to callers).
 */
export function useConfirmableClick<E>(
  onClick: ((event: E) => unknown) | undefined,
  confirmDelete?: ConfirmDeleteProp
) {
  const { confirmDelete: askDelete, isCancelled } = useDeleteConfirm();

  return useCallback(
    async (event: E) => {
      if (confirmDelete) {
        try {
          await askDelete(typeof confirmDelete === "object" ? confirmDelete : {});
        } catch (error) {
          if (isCancelled(error)) {
            return;
          }
          throw error;
        }
      }
      return onClick?.(event);
    },
    [onClick, confirmDelete, askDelete, isCancelled]
  );
}
